import { getUrlParam } from './common';

export function isABTestCandidate(pathname: string) {
    // list of eligible pathname segments to be included in A/B test consideration logic
    const eligiblePathnameSegments = ['enroll/sample-page'];

    // URL parameter determining A/B test participation
    const isAbTestUrlParam = getUrlParam('abtest');

    // find the answer
    let answer = false;
    if (eligiblePathnameSegments.some((path) => pathname.includes(path))) {
        if (isAbTestUrlParam === 'true') answer = true;
    }

    return answer;
}
